/* Component Dependencies */
var createOnlineAccountTemplate = require('templates/createOnlineAccount.hbs');
var AriesComponent = require('libs/aries-component');
var toggleFormFields = require('rewards_libs/toggleFormFields');

AriesComponent.create({
  type: 'createOnlineAccount',
  template: {
    'createOnlineAccount': createOnlineAccountTemplate
  },
  subscribe: {
    
    'ADJUST_SELECT_WIDTH': 'adjustSelectWidth'
  },
  bindEvents: function() {
    toggleFormFields.initialize(this.$el);
    var lookupLink = $(".js-lookup a");
    lookupLink.attr('custom_click_track_value',"Activate Online Account|Look Up Member Number Link|internal|event167").addClass('custom_click_track');    
  },
  adjustSelectWidth : function _adjustSelectWidth(){
  	setTimeout(function(){
     $(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-select');
    },200);
  }
});
